import type { WeatherGridFrame } from "./WeatherGrid";

/** The national precipitation lattice every day file is laid out on: whole tenths of a degree over
 *  CONUS and southern Canada (north, west and east as far as MRMS reaches), row 0 at latitude
 *  54.9 and column 0 at longitude −129.9 (API `types/precip.py`).
 *
 *  `@__PURE__` tells the bundler the freeze has no side effects. Without it, this module and every
 *  module that imports it count as having side effects, so the eagerly loaded `@domain/Weather`
 *  barrel would pull the day-file decoder (precipDay.ts) into the initial bundle. */
export const PRECIP_LATTICE: Readonly<WeatherGridFrame & { step: number }> = /* @__PURE__ */ Object.freeze({
	west: -129.9,
	south: 24,
	east: -60.1,
	north: 54.9,
	cols: 699,
	rows: 310,
	step: 0.1,
});

/** Lattice points in one plane (cols * rows). */
export const PRECIP_POINTS = 216_690;

/** A day file's length: four bytes per point (after the browser undoes Content-Encoding: gzip). */
export const PRECIP_DAY_BYTES = 4 * PRECIP_POINTS;

/** The manifest layout this client reads (API `types/precip.py` MANIFEST_VERSION). */
export const PRECIP_MANIFEST_VERSION = 2;

/** The planes a day file holds: the day's total, its wet hours, and its peak chance of rain. */
export type PrecipPlane = "total" | "hours" | "chance";
